import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Core components
import Table from 'components/core/table/Table';
import TableHead from 'components/core/table/TableHead';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Models
import {
  smsColumns, smsType, smsStatus, sortSmsHistory,
} from 'models/device';
// Custom
import { getDeviceSmsHistory, getDeviceSmsStatus } from 'actions';
import { deviceSmsListShape, userOperationShape } from 'constants/PropTypesShapes';
import { computeErrors } from 'utils/Forms';
import withStateReinit from 'hocs/WithStateReinit';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import { GetIconButton } from 'components/buttons/IconButtons';
import AppIcon from 'components/icons/AppIcon';

class DeviceSmsHistory extends React.Component {
  constructor(props) {
    super(props);

    this.handleCheckSmsStatus = this.handleCheckSmsStatus.bind(this);
  }

  componentDidMount() {
    // Load history
    const { id, handleGetSmsHistory } = this.props;
    handleGetSmsHistory(id);
  }

  // Handlers
  handleCheckSmsStatus(idSms) {
    const { id, handleGetDeviceSmsStatus } = this.props;
    handleGetDeviceSmsStatus(id, idSms);
  }

  render() {
    const { smsList, smsGetStatus } = this.props;

    // Compute errors
    const errors = computeErrors(null, smsGetStatus.error);

    const smsElements = sortSmsHistory(smsList.elements);

    return (
      <LoadingDisplayer loading={smsList.loading} mountChildrenWhileLoading>
        <ErrorsDisplayer errors={errors} noFormRef />
        <Table
          loading={smsList.loading}
          hasElements={!!smsElements}
          head={(
            <TableHead
              columns={smsColumns}
              adjustForActions
              nbActions={1}
            />
          )}
        >
          {!!smsElements && _map(smsElements, (sms) => {
            const type = smsType(sms);
            const status = smsStatus(sms);
            if (type && status) {
              return (
                <TableRow key={_toString(sms.id)}>
                  <TableCell>
                    <LocalizedStandardDate value={sms.date} />
                  </TableCell>
                  <TableCell noPadding>
                    <div className="d-flex align-items-center">
                      <AppIcon defaultColor id={type.icon} />
                      <div className="pl-2 text-truncate">
                        <LocalizedMessage id={type.labelId} />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="table-content-2" noPadding>
                    <div className="d-flex align-items-center">
                      <AppIcon color={status.color} id={status.icon} />
                      <div className="pl-2 text-truncate">
                        <LocalizedMessage id={status.labelId} />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="table-actions-1" noPadding>
                    {status.value === 'pending'
                      && <GetIconButton onClick={() => this.handleCheckSmsStatus(sms.id)} tooltipId="tooltip.getStatus" />}
                  </TableCell>
                </TableRow>
              );
            }
            return null;
          })}
        </Table>
      </LoadingDisplayer>
    );
  }
}

DeviceSmsHistory.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  smsList: deviceSmsListShape.isRequired,
  smsGetStatus: userOperationShape.isRequired,
  handleGetSmsHistory: PropTypes.func.isRequired,
  handleGetDeviceSmsStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  smsList: state.deviceSms.list,
  smsGetStatus: state.deviceSms.getStatus,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetSmsHistory: (id) => {
    dispatch(getDeviceSmsHistory(id));
  },
  handleGetDeviceSmsStatus: (id, idSms) => {
    dispatch(getDeviceSmsStatus(id, idSms));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStateReinit(['deviceSms']),
)(DeviceSmsHistory);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceSmsHistory.js